import BaseDilog from '@/components/module/baseDialog.vue'
import FootBar from '@/views/system/flow/copmponents/sales/common/FootSubmit.vue'
const MyPluing = {}
MyPluing.install = (Vue) => {
  // eslint-disable-next-line no-unused-expressions
  Vue.component('BaseDialog', BaseDilog)
  Vue.component('FootBar', FootBar)
}
export default MyPluing
